// eslint-disable-next-line import/no-unresolved
import Logger from '@cvent/logging';
import { datadogLogs } from '@datadog/browser-logs';
import { getDatadogLogsConfig } from './datadogConfig';
import getEnvVar from '../utils/getEnvVar';

/**
 * This logger will be handled all logs based on defined destinations.
 * It also functions like console.log. If datadog is null (as it is in the development environment), it sends all logs
 * to the console.
 * We can also add more logging destinations if needed.
 * (https://github.com/cvent-internal/development-framework/tree/main/packages/logging#transports).
 */
export default class CvtLogger extends Logger {
    constructor(loggerName, config = {}) {
        const level = config.level || getEnvVar('LOG_LEVEL', 'warn');

        super(loggerName, {
            level,
            datadog: getEnvVar('ENV_NAME', 'development') !== 'development' && getDatadogLogsConfig(),
            ...config,
        });
    }
}

export const setUserOnGlobalLogContext = (id, email, organizationId, ddUserId) => {
    datadogLogs.setGlobalContextProperty('ddUserId', ddUserId);
    datadogLogs.setGlobalContextProperty('user.id', ddUserId);
    datadogLogs.setGlobalContextProperty('splash.user.id', id);
    datadogLogs.setGlobalContextProperty('splash.user.email', email);
    datadogLogs.setGlobalContextProperty('splash.user.organizationId', organizationId);
};

export const setEventOnGlobalLogContext = (id, title) => {
    datadogLogs.setGlobalContextProperty('splash.event.id', id);
    datadogLogs.setGlobalContextProperty('splash.event.title', title);
};
